import React from 'react';
import Reflux from 'reflux';
import Field from '../../common/Field';
import Validator from '../../common/Validator';
import moment from 'moment';
import 'moment/locale/hu';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-date-picker';
import i18 from '../../../i18';
import {customerApi} from '../../../api';
import api from "../../../source/api";

class Upload extends Reflux.Component {
    constructor(props) {
        super(props);

        this.state = {
            processing: false,
            fields: this.createInitialFields(props.config),
            startDate: this.createDate(props.config.start_date),
            endDate: this.createDate(props.config.end_date),
            date: {
                error: '',
            },
        };
    }

    componentDidMount() {
        moment.locale('hu');
        window.scrollTo(0, 0);
    }

    createInitialFields = (config) => {
        return {
            date_type: this.createField(
                config.date_type,
                true,
            ),

            registration_number_cash_huf: this.createField(
                config.registration_number_cash_huf,
                true,
            ),

            registration_number_cash_foreign: this.createField(
                config.registration_number_cash_foreign,
                true,
            ),

            registration_number_transfer_huf: this.createField(
                config.registration_number_transfer_huf,
                true,
            ),

            registration_number_transfer_foreign: this.createField(
                config.registration_number_transfer_foreign,
                true,
            ),

            registration_number_card_huf: this.createField(
                config.registration_number_card_huf,
                true,
            ),

            registration_number_card_foreign: this.createField(
                config.registration_number_card_foreign,
                true,
            ),

            registration_number_voucher_huf: this.createField(
                config.registration_number_voucher_huf,
                true,
            ),

            registration_number_voucher_foreign: this.createField(
                config.registration_number_voucher_foreign,
                true,
            ),

            registration_number_other_huf: this.createField(
                config.registration_number_other_huf,
                true,
            ),

            registration_number_other_foreign: this.createField(
                config.registration_number_other_foreign,
                true,
            ),

            export_date_type: this.createField(
                config.export_date_type,
                true,
            ),

            job_number: this.createField(
                config.job_number,
                false,
            ),

            inputXml: this.createField(
                '',
                true,
            ),
        };
    };

    createField = (value, required) => {
        return {
            value: value || '',
            error: '',
            role: {
                required: required,
            },
        };
    };

    createDate = (date) => {
        if (!date) {
            return null;
        }

        const parsedDate = new Date(date);

        if (isNaN(parsedDate.getTime())) {
            return null;
        }

        return parsedDate;
    };

    getCompanyId = () => {
        return this.props.config.company_id;
    };

    handleStartDateChange = (date) => {
        this.setState({
            startDate: date,
            date: {
                error: '',
            },
        });
    };

    handleEndDateChange = (date) => {
        this.setState({
            endDate: date,
            date: {
                error: '',
            },
        });
    };

    setValue = (name, value, error) => {
        const fields = Object.assign(
            {},
            this.state.fields,
        );

        fields[name] = Object.assign(
            {},
            fields[name],
            {
                value: value,
                error: error,
            },
        );

        this.setState({
            fields: fields,
        });
    };

    onChangeSelect = (event) => {
        const name = event.target.name;
        const value = event.target.value;

        this.setValue(
            name,
            value,
            '',
        );
    };

    getInputFile = () => {
        const input = document.querySelector('#inputXml');

        if (
            !input
            || !input.files
            || input.files.length === 0
        ) {
            return null;
        }

        return input.files[0];
    };

    validateDates = () => {
        const startDate = this.state.startDate;
        const endDate = this.state.endDate;

        if (!startDate || !endDate) {
            this.setState({
                date: {
                    error: 'Kérjük, adja meg a kezdő és záró dátumot!',
                },
            });

            return false;
        }

        if (moment(startDate).isAfter(moment(endDate), 'day')) {
            this.setState({
                date: {
                    error:
                        'A kezdő dátum nem lehet későbbi a záró dátumnál!',
                },
            });

            return false;
        }

        this.setState({
            date: {
                error: '',
            },
        });

        return true;
    };

    prepareFieldsForValidation = () => {
        const fields = Object.assign(
            {},
            this.state.fields,
        );

        fields.inputXml = Object.assign(
            {},
            fields.inputXml,
            {
                role: Object.assign(
                    {},
                    fields.inputXml.role,
                    {
                        required: true,
                    },
                ),
            },
        );

        return fields;
    };

    validate = () => {
        const fields = this.prepareFieldsForValidation();

        const validator = Validator.validate(fields);
        const datesValid = this.validateDates();

        if (validator.error || !datesValid) {
            this.setState({
                error: validator.error,
                fields: validator.fields,
            });

            return false;
        }

        if (!this.getInputFile()) {
            const validatedFields = Object.assign(
                {},
                validator.fields,
            );

            validatedFields.inputXml = Object.assign(
                {},
                validatedFields.inputXml,
                {
                    error: 'Kérjük, válasszon ki egy XML-fájlt!',
                },
            );

            this.setState({
                fields: validatedFields,
                error: true,
            });

            return false;
        }

        this.setState({
            fields: validator.fields,
            error: false,
        });

        return true;
    };

    appendRegistrationNumbers = (form) => {
        const fields = this.state.fields;

        const registrationFields = [
            'registration_number_cash_huf',
            'registration_number_cash_foreign',
            'registration_number_transfer_huf',
            'registration_number_transfer_foreign',
            'registration_number_card_huf',
            'registration_number_card_foreign',
            'registration_number_voucher_huf',
            'registration_number_voucher_foreign',
            'registration_number_other_huf',
            'registration_number_other_foreign',
        ];

        registrationFields.forEach((fieldName) => {
            form.append(
                fieldName,
                fields[fieldName].value,
            );
        });
    };

    appendDates = (form) => {
        form.append(
            'start_date',
            moment(this.state.startDate).format(
                'YYYY-MM-DD',
            ),
        );

        form.append(
            'end_date',
            moment(this.state.endDate).format(
                'YYYY-MM-DD',
            ),
        );
    };

    buildSubmitForm = () => {
        const form = new FormData();

        this.appendDates(form);
        this.appendRegistrationNumbers(form);


        form.append(
            'inputFile',
            this.getInputFile(),
        );

        return form;
    };

    buildExportForm = () => {
        const form = new FormData();

        this.appendDates(form);

        form.append(
            'inputFile',
            this.getInputFile(),
        );

        return form;
    };

    getErrorMessage = (error, fallbackMessage) => {
        if (
            error
            && error.response
            && error.response.data
        ) {
            const responseData = error.response.data;

            if (
                responseData.error
                && responseData.error.message
            ) {
                return responseData.error.message;
            }

            if (responseData.message) {
                return responseData.message;
            }
        }

        return fallbackMessage;
    };

    nextStep = async () => {
        if (this.state.processing) {
            return;
        }

        if (!this.validate()) {
            return;
        }

        this.setState({
            processing: true,
        });

        try {
            const form = this.buildSubmitForm();

            const data = await customerApi.upload(
                this.getCompanyId(),
                form,
            );

            if (
                data.outOfRange
                && data.outOfRange > 0
            ) {
                this.props.notifyError(
                    data.outOfRange
                    + ' számla kívül esik a dátumintervallumon!',
                    'error',
                );
            }

            this.props.updateConfig(
                data.config,
            );

            this.props.updateInvoices(
                data.invoices,
                this.props.customerRules,
            );

            this.props.nextStep();
        } catch (error) {
            console.log(error)
            this.props.notifyError(
                this.getErrorMessage(
                    error,
                    'Hiba történt a számlák betöltése során. (#1003)',
                ),
            );
        } finally {
            this.setState({
                processing: false,
            });
        }
    };

    exportInvoices = async () => {
        if (this.state.processing) {
            return;
        }

        if (!this.validate()) {
            return;
        }

        const companyId = this.getCompanyId();

        this.setState({
            processing: true,
        });

        try {
            const responseData = await customerApi.generateExcel(
                companyId,
                this.buildExportForm(),
            );

            if (!responseData || !responseData.name) {
                throw new Error(
                    'A generált fájl neve hiányzik.',
                );
            }

            const url = customerApi.downloadUrl(companyId);

            api.downloadFile(
                url,
                responseData.name,
            );
        } catch (error) {
            this.props.notifyError(
                this.getErrorMessage(
                    error,
                    'Hiba történt az Excel-export készítése során.',
                ),
            );
        } finally {
            this.setState({
                processing: false,
            });
        }
    };

    renderField = (name) => {
        return (
            <Field
                type="text"
                id={name}
                name={name}
                label=""
                classLabel="control-label"
                classInput="bordered-input"
                setValue={this.setValue}
                state={this.state}
                style={{
                    width: '100%',
                }}
            />
        );
    };

    renderRegistrationRow = (
        title,
        hufField,
        foreignField,
    ) => {
        return (
            <tr>
                <td>{title}</td>

                <td className="text-center">
                    {this.renderField(hufField)}
                </td>

                <td className="text-center">
                    {this.renderField(foreignField)}
                </td>
            </tr>
        );
    };

    renderDateSelection = () => {
        return (
            <div className="row">

                <div className="col-6">
                    <p>
                        Számlák betöltése teljesítési
                        dátum alapján:
                    </p>
                </div>

                <div className="col-3">
                    <DatePicker
                        className="date-picker"
                        value={this.state.startDate}
                        onChange={this.handleStartDateChange}
                        required={true}
                        showLeadingZeros={true}
                        disabled={this.state.processing}
                    />
                </div>

                <div className="col-3">
                    <DatePicker
                        className="date-picker"
                        value={this.state.endDate}
                        onChange={this.handleEndDateChange}
                        required={true}
                        showLeadingZeros={true}
                        disabled={this.state.processing}
                    />
                </div>
            </div>
        );
    };

    renderDateError = () => {
        if (!this.state.date.error) {
            return null;
        }

        return (
            <div className="row">
                <div className="col-md-6 offset-md-3">
                    <p className="help-block help-block-error">
                        <span className="error">
                            <i className="fa fa-warning"/>
                            {' '}
                            {this.state.date.error}
                        </span>
                    </p>
                </div>
            </div>
        );
    };

    renderConfigurationTable = () => {
        return (
            <React.Fragment>
                <table className="table table-striped table-aibook-bordered">
                    <thead>
                    <tr>
                        <th style={{width: '50%'}}>
                            Fizetés típusa
                        </th>

                        <th style={{width: '25%'}}>
                            Forintos
                        </th>

                        <th style={{width: '25%'}}>
                            Devizás
                        </th>
                    </tr>
                    </thead>

                    <tbody>
                    {this.renderRegistrationRow(
                        'KÉSZPÉNZES SZÁMLÁK RÖGZÍTÉSE',
                        'registration_number_cash_huf',
                        'registration_number_cash_foreign',
                    )}

                    {this.renderRegistrationRow(
                        'ÁTUTALÁSOS SZÁMLÁK RÖGZÍTÉSE',
                        'registration_number_transfer_huf',
                        'registration_number_transfer_foreign',
                    )}

                    {this.renderRegistrationRow(
                        'BANKKÁRTYÁS SZÁMLÁK RÖGZÍTÉSE',
                        'registration_number_card_huf',
                        'registration_number_card_foreign',
                    )}

                    {this.renderRegistrationRow(
                        'UTALVÁNYOS SZÁMLÁK RÖGZÍTÉSE',
                        'registration_number_voucher_huf',
                        'registration_number_voucher_foreign',
                    )}

                    {this.renderRegistrationRow(
                        'EGYÉB SZÁMLÁK RÖGZÍTÉSE',
                        'registration_number_other_huf',
                        'registration_number_other_foreign',
                    )}

                    </tbody>
                </table>

                <div className="row mt-3">

                    <label
                        htmlFor="inputXml"
                        className="col-md-6 text-right"
                    >
                        XML-fájl alapú számlafeldolgozás
                    </label>


                    <Field
                        type="file"
                        id="inputXml"
                        name="inputXml"
                        fileUploadEndpoint=""
                        classLabel="control-label"
                        classInput="file-input"
                        setValue={this.setValue}
                        state={this.state}
                        style={{
                            width: '350px',
                            margin: 'auto',
                        }}
                    />
                </div>

            </React.Fragment>
        );
    };

    renderActions = () => {
        const buttonClass = this.state.processing
            ? 'disabled next-step mr-2'
            : 'next-step mr-2';

        return (

            <div className="row">

                <div
                    className="next-step-btn-container text-center mt-4 py-3"
                    style={{
                        width: '100%',
                    }}
                >
                    <a
                        onClick={
                            this.state.processing
                                ? null
                                : () => this.exportInvoices()
                        }
                        className={buttonClass}
                    >
                        Számlák Excel-exportálása
                    </a>

                    <a
                        onClick={
                            this.state.processing
                                ? null
                                : () => this.nextStep()
                        }
                        className={buttonClass}
                    >
                        {this.state.processing
                            ? i18.BUTTONS._processing
                            : i18.BUTTONS
                                ._goToAccountAssignment}
                    </a>

                </div>
            </div>
        );
    };

    render() {
        return (
            <div className="row">
                <div className="col-md-10 offset-md-1">
                    {this.renderDateSelection()}
                    {this.renderDateError()}
                    {this.renderConfigurationTable()}
                    {this.renderActions()}
                </div>
            </div>
        );
    }
}

export default Upload;


// WEBPACK FOOTER //
// ./src/components/customer/steps/Upload.js